/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const ActivityType = {

	delete (context, id, onSuccess, onError, options) {
		Api.delete(context,
			"/activity-type"
			+ "?id=" + id
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getListAll (context, onSuccess, onError, options) {
		Api.get(context,
			"/activity-type/list-all"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, activityTypeDTO, onSuccess, onError, options) {
		Api.post(context,
			"/activity-type"
			, activityTypeDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, activityTypeDTO, onSuccess, onError, options) {
		Api.put(context,
			"/activity-type"
			, activityTypeDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
